import { formatNumber } from '../../node_modules/@web/tesla-lang';
/**
 * Unit Conversion and localization helper functions.
 */

/**
 * @description Converts Miles to KM
 * @param {number} miles - miles value
 * @returns {number} km value
 */
export function mileToKM(miles) {
  return miles * 1.609344;
}

/**
 * @description Converts Miles to KM
 * @param {number} meter - miles value
 * @returns {number} km value
 */
export function meterToKM(meter) {
  return meter / 1000;
}

/**
 * @description Converts Miles to KM
 * @param {number} km - miles value
 * @returns {number} mile value
 */
export function kmToMile(km) {
  return km * 0.62137119;
}

/**
 * @description Converts Price per Gallon to price per liter
 * @param {number} price - price per gallon in a given currency
 * @returns {number} return price per liter in given currency
 */
export function pricePerGallonToPricePerLiter(price) {
  return price / 3.78541178;
}

/**
 * @description Converts fuel efficiency mpg to l/100km
 * @param {number} mpg - MPG (US Gallon)
 * @returns {number} return l/100km value
 */
export function mpgToLitersPer100km(mpg) {
  return (100 * 3.785411784) / (1.609344 * mpg);
}

/**
 * @description wrapper function to only convert mile to KM for imperial system locale
 * @param {number} miles - distance in miles
 * @param {string} locale - locale eg: 'fr_FR'
 * @returns {number} return distance in KM or miles.
 */
export function localizeDistance(distance, localeUnit, inputUnit) {
  let localizedDistance = distance;

  if (localeUnit.system.distance !== inputUnit) {
    if (localeUnit.system.distance === 'metric') {
      localizedDistance = mileToKM(distance);
    } else if (localeUnit.system.distance === 'imperial') {
      localizedDistance = kmToMile(distance);
    }
  }

  return localizedDistance;
}

/**
 * @description
 * @param {number} distance - format distance string per locale and add unit / mi/ km
 * @param {string} locale - eg: 'en_US'
 * @param {object} unit - unit object with imperial and metric strings
 * @returns {string} eg return string: '400 m', '2km', '0.4 mi', '2mi'
 */
export function formatDistance(distance, unit, locale) {
  let precision = distance >= 100 ? 0 : 1;
  let humanizedDistance = distance;
  let updatedUnit = unit.distance.shorthand;

  if (unit.system.distance === 'metric') {
    if (distance < 1) {
      humanizedDistance *= 1000;
      precision = 0;
      updatedUnit = unit.distance.smallDistanceShorthand;
    }
  }

  return `${formatNumber(humanizedDistance, precision, locale)} ${updatedUnit}`;
}

/**
 * @description Converts liter/100km value to km/l value
 * @param {number} efficiencyVal - efficiencyVal in liter/100km
 * @returns {number} km/l value
 */
export function litersPer100kmToKmPerLiter(efficiencyVal) {
  return (100 / efficiencyVal).toFixed(2);
}
